import { useLoaderData } from "react-router";
import { Col, Container, Row } from "react-bootstrap";
import type { CourseEvent } from "~/models/courseEvent";
import UpcomingList from "./upcoming/upcoming-list";
import ImageCarousel from "./upcoming/image-carousel";

export default function UpcomingSection() {
    const { events } = useLoaderData<{ events: CourseEvent[] | null }>();

    if (!events || events.length === 0) return null;

    return (
        <section id="upcoming-courses" className="courses" style={{ scrollMarginTop: 70 }}>
            <div className="container" data-aos="fade-up">

                <div className="section-title">
                    <h2>Courses</h2>
                    <p>Upcoming Courses</p>
                </div>
                <Container className="upcoming-events" fluid>
                    <Row>
                        <Col lg="6">
                            <UpcomingList events={events} />
                        </Col>
                        <Col lg="6" className="d-none d-lg-block">
                            <ImageCarousel />
                        </Col>
                    </Row>
                </Container>
            </div>
        </section>
    );
}
